import {Component, OnInit} from '@angular/core';
import {User} from '../../../dtos/user';
import {UserService} from '../../../services/user/user.service';
import {AuthService} from '../../../services/auth/auth.service';
import {Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {DeleteAccountDialogComponent, DeleteAccountDialogData} from '../delete-account-dialog/delete-account-dialog.component';
import {ChangePasswordComponent} from '../change-password/change-password.component';
import {EditProfileComponent} from '../edit-profile/edit-profile.component';
import {NotificationService} from '../../../services/common/notification.service';
import {SettingsDialogComponent} from '../settings-dialog/settings-dialog.component';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss'],
    standalone: false
})
export class ProfileComponent implements OnInit {
  currentUser: User;

  tableData: any[]; // TODO check with Max, einfach von unten übernehmen?

  displayedColumns: string[] = ['fields', 'data'];

  constructor(private notificationService: NotificationService,
              private userService: UserService,
              public authService: AuthService,
              public dialog: MatDialog,
              private router: Router) {
  }

  ngOnInit(): void {
    this.userService.getCurrentUser().subscribe(user => {
      this.currentUser = user;
      this.tableData = this.buildTableData(user);
    }, error => {
      this.notificationService.openSnackBar(error.error);
    });
  }

  editProfile(): void {
    const dialogRef = this.dialog.open(EditProfileComponent, {
      data: {
        user: this.currentUser
      }
    });
    dialogRef.afterClosed().subscribe(u => {
      if (u) {
        this.userService.editUser(u).subscribe(n => {
          const tempId = this.currentUser.id;
          this.currentUser = n;
          this.currentUser.id = tempId;
          this.notificationService.openSnackBar('Profil gespeichert.');
          this.tableData = this.buildTableData(n);
        }, error => {
          this.notificationService.openSnackBar(error);
        });
      }
    }, error => {
      this.notificationService.openSnackBar(error);
    });
  }

  /**
   * the user confirms with email and password in the dialog, which also deletes the account
   */
  deleteUser(): void {
    const data: DeleteAccountDialogData = {userId: this.currentUser.id};
    this.dialog.open(DeleteAccountDialogComponent, {data}).afterClosed().subscribe(deleted => {
      if (deleted) {
        this.notificationService.openSnackBar('Account erfolgreich gelöscht!');
        this.authService.logoutUser();
        this.router.navigateByUrl('/');
      }
    });
  }

  changePassword(): void {
    this.dialog.open(ChangePasswordComponent, {
      data: {
        id: this.currentUser.id
      }
    });
  }

  /**
   * rows of [label, value]; the rows for the password and the notification settings have a button instead of a value
   */
  private buildTableData(user: User): any[] {
    return [
      ['E-Mail', user.email],
      ['Vorname', user.firstName],
      ['Nachname', user.lastName],
      ['Land', user.country],
      ['Stadt', user.city],
      ['Postleitzahl', user.zip],
      ['Straße', user.street],
      ['Rolle', this.currentUserRole()],
      ['Passwort', null, 'password'],
      ['E-Mail-Benachrichtigungen', null, 'settings']
    ];
  }

  openSettings(): void {
    this.dialog.open(SettingsDialogComponent);
  }

  currentUserRole(): string {
    const role = this.authService.getUserRole();
    switch (role) {
      case 'ROLE_ADMIN':
        return 'Admin';
      case 'ROLE_USER_PAID':
        return 'Premium Nutzer';
      case 'ROLE_USER_FREE':
        return 'Standard Nutzer';
    }
  }

}
